import { forwardRef, type Ref, type SVGProps } from "react";
const IconTrendingOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 9h-9a1 1 0 0 0 0 2h6.41l-9.5 9.59-6.7-7.11a1 1 0 0 0-.7-.32 1.1 1.1 0 0 0-.72.28l-6.48 6.1a1 1 0 0 0 0 1.39A1 1 0 0 0 3.7 21l5.73-5.41 6.73 7.13a1 1 0 0 0 .72.32 1 1 0 0 0 .72-.3L28 12.21V19a1 1 0 0 0 2 0v-9a1 1 0 0 0-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconTrendingOutlineSVG);
ForwardRef.displayName = "IconTrendingOutline";
export { ForwardRef as IconTrendingOutline };
